module.exports = __webpack_public_path__ + "static/img/home_bottom_04.32dd69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_04.jpg
// module id = phUV
// module chunks = 1